import { CSSpot_Settings } from '@websrc/Typings/ContentStack'
import clsx from 'clsx'
import React, { ReactNode } from 'react'

import {
  spotContentBackground,
  spotContentDecoration,
  spotContentSpacing,
  spotContentWidth,
} from './SpotContentDecoration.css'

type Props = {
  children: ReactNode
  spotSettings: CSSpot_Settings
}

export default function SpotContentDecoration({ children, spotSettings }: Props) {
  const backgroundColor = spotSettings?.content_background_color?.toLowerCase() as
    | 'none'
    | 'brand'
    | 'light'
    | 'dark'
    | 'white'
    | null
  const spacing = spotSettings?.content_inner_spacing?.toLowerCase() as
    | 'none'
    | 'small'
    | 'standard'
    | 'medium'
    | 'large'
    | null

  const width = spotSettings?.content_width?.toLowerCase() as
    | 'small'
    | 'medium'
    | 'large'
    | 'full'
    | null

  const decorations = spotSettings?.content_decorations?.map(
    (decoration) =>
      decoration?.toLowerCase().replace(' ', '_') as 'border_radius' | 'box_shadow' | null
  )

  return (
    <div
      className={clsx(
        backgroundColor ? spotContentBackground[backgroundColor] : spotContentBackground['white'],
        spacing ? spotContentSpacing[spacing] : spotContentSpacing['none'],
        width ? spotContentWidth[width] : spotContentWidth['full'],
        decorations?.includes('border_radius') ? spotContentDecoration['border_radius'] : {},
        decorations?.includes('box_shadow') ? spotContentDecoration['box_shadow'] : {}
      )}
    >
      {children}
    </div>
  )
}
